// extracted by mini-css-extract-plugin
export default {"inlineSelect":"template_tab-module___inlineSelect___edf399e9","container":"template_tab-module___container___ec534b00"};